// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"739087bc","498":"8b04a91b","703":"494d90dd"}[chunkId] + ".chunk.js";
};